<template>
  <div class="ui-container">
    <h2>Toast</h2>
    <div class="ui-block inline">
      <template v-for="color in colors" :key="color">
        <Toast
          :color="color"
          icon="bi bi-fan"
          title="Title"
          text="Lorem ipsum lorem ipsum lorem ipsum"
        />
      </template>
    </div>
  </div>
</template>

<script setup>
const colors = ["yellow", "red", "green", "orange"];
</script>
